import {Component, OnInit, ViewChild} from '@angular/core';
import {NewAccessCardService} from '../service/new-access-card.service';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {NgxSpinnerService} from 'ngx-spinner';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import {DatePipe} from '@angular/common';
import {ModErrorComponent} from '../modals/mod-error/mod-error.component';
import {MAT_MOMENT_DATE_FORMATS, MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS,} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';


@Component({
  selector: 'app-new-cards-list',
  templateUrl: './new-cards-list.component.html',
  styleUrls: ['./new-cards-list.component.css'],
  providers: [
    {provide: MAT_DATE_LOCALE, useValue: 'es'},
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    {provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS},
  ],
})
export class NewCardsListComponent implements OnInit {
  @ViewChild('paginator') paginator: MatPaginator;
  pageSizeOptions: any [] = [5, 10, 20];
  pageSize = 10;
  pageNumber = 1;
  user = 2;
  SeeItems: any[] = [];
  totalPage: any [] = [];
  totalItems: number;
  statusOptions: any;


  //-----------Filters
  requestF: string;
  typeF: string;
  statusF: string;
  requestDateF: string;
  order: string;
  baseReq: string;
  //-----------------asc&desc state---------------------
  requestDesc = false;
  typeDesc = false;
  statusDesc = false;
  requestDateDesc = false;
  //---------------datepicker
  maxDate: Date;
  dateSelectStart: Date;
  dateSelectEnd: Date;

  constructor(private dataApi: NewAccessCardService,
              private spinner: NgxSpinnerService,
              private _snackBar: MatSnackBar,
              private datePipe: DatePipe,
              public dialog: MatDialog
  ) {
    this.maxDate = new Date();
    this.requestF = '';
    this.typeF = '';
    this.statusF = '';
    this.requestDateF = '';
    this.order = '&order_by=requestNumber&desc=true';
    this.baseReq = this.order;
  }

  getallallcards() {
    this.spinner.show('loading');
    this.dataApi.getallcards(this.pageNumber, this.pageSize, this.baseReq
    ).subscribe((data: any) => {
      this.SeeItems = data.items;
      this.statusOptions = data.statuses;
      this.pageNumber = data.paginator.page;
      this.pageSize = data.paginator.limit;
      this.totalPage = data.paginator.totalPages;
      this.totalItems = data.paginator.totalItems;
      this.spinner.hide('loading');
    }, (err) => {
      this.spinner.hide('loading');
      if(err.error.error !== 'Invalid token.') {
        this.dialog.open(ModErrorComponent, {
          width: 'auto',
          panelClass: 'myapp-no-padding-dialog',
        });
      }
    });
  }

  ngOnInit() {
    this.getallallcards();
  }

  handlePage(e: PageEvent) {
    this.pageSize = e.pageSize;
    this.pageNumber = e.pageIndex + 1;
    this.getallallcards();
  }

  //------ method set filters ---
  orderby(nameColumn, typeAsc) {
    switch (nameColumn) {
      case 'requestNumber': {
        this.requestDesc = !this.requestDesc;
        this.typeDesc = false;
        this.statusDesc = false;
        this.requestDateDesc = false;
        break;
      }
      case 'type': {
        this.requestDesc = false;
        this.typeDesc = !this.typeDesc;
        this.statusDesc = false;
        this.requestDateDesc = false;
        break;
      }
      case 'status': {
        this.requestDesc = false;
        this.typeDesc = false;
        this.statusDesc = !this.statusDesc;
        this.requestDateDesc = false;
        break;
      }
      case 'requestDate': {
        this.requestDesc = false;
        this.typeDesc = false;
        this.statusDesc = false;
        this.requestDateDesc = !this.requestDateDesc;
        break;
      }
    }
    const param = `&order_by=${nameColumn}&desc=${typeAsc}`;
    this.order = param;
    this.getallCardFilter();
  }

  requestFilter() {
    if (this.requestF === '' || this.requestF === null || this.requestF === undefined) {
      return '';
    } else {
      return '&requestNumber=' + this.requestF;
    }
    ;
  }

  TypeFilter() {
    if (this.typeF === '' || this.typeF === null || this.typeF === undefined) {
      return '';
    } else {
      return '&type=' + this.typeF;
    }
    ;
  }

  StatusFilter() {
    if (this.statusF === '' || this.statusF === null || this.statusF === undefined) {
      return '';
    } else {
      return '&status=' + this.statusF;
    }
    ;
  }

  DateRangeFilter() {

    let anio = new Date();
    anio.setFullYear(2099, 12, 31);
    let aniofin = new Date();
    aniofin.setFullYear(2009, 12, 31);

    if (this.dateSelectEnd === null || this.dateSelectEnd === undefined) {

      this.dateSelectEnd = anio;
    }

    if (this.dateSelectStart === null || this.dateSelectStart === undefined) {

      this.dateSelectStart = aniofin;
    }

    if (this.dateSelectStart === null || this.dateSelectStart === undefined ||
      this.dateSelectEnd === null || this.dateSelectEnd === undefined) {
      return '';
    } else {
      return '&startDate=' + this.transformDate(this.dateSelectStart) + '&endDate=' + this.transformDate(this.dateSelectEnd);
    }
    ;
  }

  transformDate(date: Date) {
    return (this.datePipe.transform(date, 'yyyy-MM-dd'));
  }

  getallCardFilter() {
    if (this.dateSelectStart && this.dateSelectEnd) {
      if (this.dateSelectStart > this.dateSelectEnd) {
        this._snackBar.open('Invalid Date Filter', '', {
          duration: 3000,
        });
        return;
      }
    }
    this.baseReq = this.order + this.TypeFilter() + this.StatusFilter() + this.requestFilter() + this.DateRangeFilter();
    this.applyFilter(this.baseReq);
  }

  applyFilter(filterUrl) {
    this.spinner.show('loading');
    this.paginator.firstPage();
    this.dataApi.getallcards(this.pageNumber, this.pageSize, filterUrl
    ).subscribe((data: any) => {
      this.SeeItems = data.items;
      this.statusOptions = data.statuses;
      this.pageNumber = data.paginator.page;
      this.pageSize = data.paginator.limit;
      this.totalPage = data.paginator.totalPages;
      this.totalItems = data.paginator.totalItems;
      this.spinner.hide('loading');
    }, (err) => {
      this.spinner.hide('loading');
      if(err.error.error !== 'Invalid token.') {
        this.dialog.open(ModErrorComponent, {
          width: 'auto',
          panelClass: 'myapp-no-padding-dialog',
        });
      }
    });
  }

  clearFilter() {

    this.maxDate = new Date();
    this.dateSelectStart = null;
    this.dateSelectEnd = null;
    this.requestF = '';
    this.typeF = '';
    this.statusF = '';
    this.requestDateF = '';
    this.order = '&order_by=requestNumber&desc=true';
    this.getallCardFilter();
  }

  
  isNegative(requestF:string){
    let evaluate=Number(requestF)
    if(evaluate<0) {
      return true
    }
    else {
      return false;
    }  

  }


}
